<template src="./SidebarComponent.html"></template>
<script>
import IconDashboard from "@/components/icons/IconDashboard.vue";
import IconInvoice from "@/components/icons/IconInvoice.vue";
import IconChevronRight from "@/components/icons/iconChevronRight.vue";
import {ref, onMounted, computed} from "vue";
import CommonService from "@/services/common.service";
import {useScreenSize} from "@/composable/useScreenSize.js";
import {useCommonStore} from "@/stores/common.js";

export default {
  name: 'SidebarComponent',
  components: {IconChevronRight, IconDashboard, IconInvoice},
  setup() {
    const dataMenu = ref({
      dashboard: {
        label: 'Bảng điều khiển',
        isActive: false,
        subMenu: {},
        icon: 'dashboard',
        url: '/',
        name: 'dashboard'
      },
      invoices: {
        label: 'Hoá đơn',
        isActive: false,
        icon: 'invoice',
        url: '',
        id: 'invoices',
        subMenu: {
          storeDeliveryData: {
            label: 'Dữ liệu giao hàng',
            isActive: false,
            url: '../delivery-data',
            name: 'delivery-data',
            icon: 'dataInvoice',
          },
          exchangeDeliveryData: {
            label: 'Giao hàng',
            isActive: false,
            url: '../exchange-delivery-data',
            name: 'exchange-delivery-data',
            icon: 'invoiceDetail',
          },
        }
      },
      employer: {
        label: 'Nhân Viên',
        isActive: false,
        icon: 'user',
        url: '',
        id: 'employer',
        subMenu: {
          listEmployer: {
            label: 'Danh sách nhân viên',
            isActive: false,
            url: '../employers',
            name: 'employer',
            icon: 'IconUser',
          }
        }
      },
      partner: {
        label: 'Đối tác',
        isActive: false,
        icon: 'partner',
        url: '',
        id: 'partner',
        subMenu: {
          listPartner: {
            label: 'Danh sách đối tác',
            isActive: false,
            url: '../partner/list',
            name: 'partner-list',
            icon: 'partnerList',
          },
          createPartner: {
            label: 'Mời đối tác',
            isActive: false,
            url: '../partner/invite',
            name: 'partner-invite',
            icon: 'partnerPlus',
          }
        }
      },
      products: {
        label: 'Sản phẩm',
        isActive: false,
        icon: 'block',
        url: '',
        id: 'products',
        subMenu: {
          listProduct: {
            label: 'Danh sách sản phẩm',
            isActive: false,
            url: '../product',
            name: 'product',
            icon: 'productList'
          },
        }
      },
      warehouses: {
        label: 'Kho hàng',
        isActive: false,
        icon: 'warehouse',
        url: '',
        id: 'warehouses',
        subMenu: {
          listWarehouses: {
            label: 'Danh sách kho hàng',
            isActive: false,
            url: '../warehouse',
            name: 'warehouse',
            icon: 'warehouseList'
          },
          managerInventory: {
            label: 'Quản lý tồn kho',
            isActive: false,
            url: '../warehouse/management-inventory',
            name: 'management-inventory',
            icon: 'warehouseManager'
          },
          arrival: {
            label: 'Nhập hàng',
            isActive: false,
            url: '../warehouse/arrival',
            name: 'arrival',
            icon: 'arrivalPlus'
          },
        }
      },
      stores: {
        label: 'Cửa hàng',
        isActive: false,
        icon: 'store',
        url: '',
        id: 'stores',
        subMenu: {
          listProduct: {
            label: 'Danh sách cửa hàng',
            isActive: false,
            url: '../store',
            name: 'store',
            icon: 'storeList'
          },
        }
      },
      settings: {
        label: 'Cài đặt',
        isActive: false,
        icon: 'setting',
        url: '',
        id: 'settings',
        subMenu: {
          exportFile: {
            label: 'Nhập file - Xuất file',
            isActive: false,
            url: '../setting/format-file',
            name: 'SettingFormatFile',
          },
        }
      },
      thirdPartyKiotviet: {
        label: 'Liên kết với KiotViet',
        isActive: false,
        icon: 'KiotViet',
        url: '',
        id: 'thirdPartyKiotviet',
        subMenu: {
          storeKiotviet: {
            label: 'Danh sách liên kết',
            isActive: false,
            url: '../third-party/sync-kiotviet',
            name: 'SyncKioviet',
            icon: 'dataInvoice',
          },
        }
      },
      thirdPartyGHTK: {
        label: 'Liên kết với GHTK',
        isActive: false,
        icon: 'GHTK',
        url: '',
        id: 'thirdPartyGHTK',
        subMenu: {
          ghtk: {
            label: 'Danh sách liên kết',
            isActive: false,
            url: '../third-party/ghtk',
            name: 'SyncGHTK',
          },
          orderGHTK: {
            label: 'Danh sách đơn hàng',
            isActive: false,
            url: '../third-party/ghtk/order',
            name: 'OrderGHTK',
          },
        }
      },
      thirdPartyZalo: {
        label: 'Liên kết với Zalo',
        isActive: false,
        icon: 'Zalo',
        url: '',
        id: 'thirdPartyZalo',
        subMenu: {
          zalo: {
            label: 'Danh sách liên kết',
            isActive: false,
            url: '../third-party/zalo/connect',
            name: 'SyncZalo',
          },
          userZalo: {
            label: 'Danh sách người dùng',
            isActive: false,
            url: '../third-party/zalo/user',
            name: 'UserZalo',
          },
          messageZalo: {
            label: 'Cài đặt tin nhắn',
            isActive: false,
            url: '../third-party/zalo/setting-message',
            name: 'messageZalo',
          },
        }
      }
    })
    const iconKeys = ['dashboard', 'invoice', 'block', 'setting', 'partner', 'warehouse', 'store', 'dataInvoice', 'invoiceDetail',
      'partnerList', 'partnerPlus', 'productList', 'warehouseList', 'warehouseManager', 'arrivalPlus', 'storeList', "GHTK", 'KiotViet', 'Zalo', 'user'];
    const iconComponents = ref({});
    const { widthScreen, isSmallScreen } = useScreenSize(1024);
    const commonStore = useCommonStore()
    onMounted(async () => {
      for (const key of iconKeys) {
        iconComponents.value[key] = await CommonService.generateIcon(key);
        commonStore.settingActiveSidebarItems(`Icon${key.charAt(0).toUpperCase()}${key.slice(1)}`, false);
      }
    });
    const generalMenu = computed(() =>
        Object.fromEntries(
            Object.entries(dataMenu.value || {}).filter(
                ([key]) =>
                    !['thirdPartyZalo', 'thirdPartyKiotviet', 'thirdPartyGHTK'].includes(key)
            )
        )
    )
    const externalMenu = computed(() =>
        Object.fromEntries(
            Object.entries(dataMenu.value || {}).filter(([key]) =>
                ['thirdPartyZalo', 'thirdPartyKiotviet', 'thirdPartyGHTK'].includes(key)
            )
        )
    )
    function toggleSubMenu(id, subKey = null) {
      for (const itemKey in dataMenu.value) {
        const item = dataMenu.value[itemKey];
        if (!subKey) {
          item.isActive = itemKey === id ? !item.isActive : false;
        }
        if (item.subMenu && Object.keys(item.subMenu).length > 0) {
          for (const subItemKey in item.subMenu) {
            const subItem = item.subMenu[subItemKey];
            if (subKey === subItemKey) {
              subItem.isActive = !subItem.isActive;
            } else {
              subItem.isActive = false;
            }
          }
        }
        if (!subKey) {
          const iconName = `Icon${item.icon.charAt(0).toUpperCase()}${item.icon.slice(1)}`;
          commonStore.settingActiveSidebarItems(iconName, item.isActive);
        }
      }
    }


    const getIcon = (iconName) => iconComponents.value[iconName];

    return {
      dataMenu,
      generalMenu,
      externalMenu,
      widthScreen,
      isSmallScreen,
      toggleSubMenu,
      getIcon
    }
  },
}
</script>
<style lang="scss">
.sidebar-wrapper {
  position: fixed;
  height: 100%;
  top: 0;
  z-index: 9;
  line-height: inherit;
  background: #fff;
  width: 265px;
  text-align: left;
  transition: .3s;
  box-shadow: 0 0 21px 0 rgba(89,102,122,.1);
  .logo-wrapper {
    padding: 27px 30px;
    box-shadow: -9px 0 20px rgba(89,102,122,.1);
  }
  .sidebar-menu {
    height: 100%;
    .sidebar-list {
      height: calc(100vh - 78px);
      overflow: hidden auto;
      transition: color 1s ease;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f2f4;
      }
      &::-webkit-scrollbar-thumb {
        background:  #dde5fb;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      .sidebar-item-title {
        padding: 10px 20px 5px;
        .box {
          border-top: 1px solid #d0d0d0;
          padding-top: 20px;
          .title {
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
      .sidebar-item {
        cursor: pointer;
        .title {
          position: relative;
          padding: 12px 20px;
          &.active {
            background: #f1f0ff;
          }
          &.active:after {
            position: absolute;
            content: "";
            width: 4px;
            height: 35px;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: #7366ff;
            border-radius: 5px 0 0 5px;
          }
        }
        .sidebar-item-children {
          position: relative;
          cursor: pointer;
          display: none;
          &.active {
            display: block;
          }
          &:before {
            position: absolute;
            content: "";
            width: 1px;
            background: rgba(82, 82, 108, .4);
            top: 0;
            left: 27px;
            height: calc(100% - 18px);
          }
          .sidebar-child {
            padding: 7px 25px 7px 48px;
            font-size: 13px;
            color: #3a3a3a;
            display: block;
            position: relative;
            letter-spacing: .06em;
            font-weight: 500;
            transition: all .3s ease;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            a {
              color: #3a3a3a;
            }
            &:before {
              position: absolute;
              content: "";
              width: 5px;
              height: 5px;
              top: 50%;
              transform: translateY(-50%);
              left: 25px;
              border-radius: 100%;
              background: #7366ff;
              opacity: 0;
              visibility: hidden;
            }
            &:after {
              position: absolute;
              content: "";
              top: 48%;
              width: 8px;
              border-top: 1px solid rgba(82, 82, 108, .4);
              left: 27px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .sidebar-wrapper {
    width: 80px;
    .logo-wrapper {
      padding: 30px 10px;
      font-size: 0.8rem;
    }
    .sidebar-menu {
      .sidebar-list {
        .sidebar-item-title {
          padding: 10px 10px 5px;
        }
        .is_submenu {
          position: relative;
        }
        .is_submenu::after {
          content: '';
          position: absolute;
          right: 0;
          top: 20%;
          transform: translateY(-50%);
          width: 0;
          height: 30px;
          background: #696cff;
          border-radius: 9999px;
          transition: width 0.3s ease;
        }
        .is_submenu.open::after {
          width: 3px;
        }
        .sidebar-item {
          .sidebar-item-children {
            &:before {
              left: 27px;
              height: calc(100% - 20px);
            }
            .sidebar-child {
              padding-left: 40px;
              white-space: nowrap;
              overflow: initial;
              text-overflow: initial;
              &:after {
                left: 27px;
              }
            }
          }
        }
      }
    }
  }
}
</style>